import React from 'react';
import { OU } from '@src/Objects/Company';
import './OUSelect.css';

interface OUSelectProps
{
    OUs: OU[]
    selectedOU: number
    setSelectedOU: (val: OU) => void
}

function OUSelect({ OUs, selectedOU, setSelectedOU }: OUSelectProps)
{
    const sortedOUs = [...OUs].sort((a, b) => a.title.localeCompare(b.title))
    return (
        <div className="oUSelect">
            <select
                value={selectedOU}
                onChange={(e) =>
                {
                    const ouId = parseInt(e.target.value);
                    setSelectedOU(OUs.find(o => o.id === ouId) as OU)
                }}
            >
                {sortedOUs.map(ou => <option
                    key={ou.id}
                    value={ou.id}
                >
                    {ou.title}
                </option>)}
            </select>
        </div>
    );
}

export default OUSelect;


